import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: "Warning",
    "is-visible": $props.isModalVisible
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        class: "_tc--accent _px-0",
        onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onCancel && $options.onCancel(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, "cancel"),
      _createElementVNode("button", {
        type: "button",
        class: "gfu-btn gfu-btn--accent gfu-btn--compact gfu-btn--soft gfu-btn--wide _ml-3",
        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onContinue && $options.onContinue(...args)), ["prevent"])),
        "data-qa": "modal-button:Continue"
      }, " Continue ")
    ]),
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("p", null, " This action will delete all test orders assigned to your account. Are you sure you want to proceed? ", -1 /* CACHED */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible"]))
}